import { render, staticRenderFns } from "./EditPeoplePage.vue?vue&type=template&id=6efa389a&"
import script from "./EditPeoplePage.vue?vue&type=script&lang=js&"
export * from "./EditPeoplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports